import React from 'react'
import CaseStudyList from '../page-specific/work/CaseStudyList'

export default class Work extends React.Component {

  componentWillMount() {
    if (this.props.content.selectedPage !== 'work') {
      this.props.changePage('work', 'side')
    }
  }

  render() {
    const setHTML = (content) => {
      return {__html: content}
    }
    return (
      <div className="page-container">
        <div className="page-contents">
          <div className="bodyContent"
               dangerouslySetInnerHTML={setHTML(this.props.content.work.copy)} />
          <CaseStudyList caseStudies={this.props.content.work.caseStudies} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Work.js